import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type ChaptersDTO = {
  id: string;
  name: string;
  description: string;
  courseId: string;
  quizId: string;
  lectures: Lecture[];
  quiz: string;
  createdAt: string;
  chapterId?: string;
  OpenLectureId?: string;
  lectureId?: string;
  updatedAt: string;
  course?: {
    id: string;
    allowDemo?: boolean;
  };
};
export type Lecture = {
  id: string;
  title: string;
  isDemo?: boolean;
  videos: Video[];
  resources: Resources[];
  quizizz?: { id: string; title: string; isDemo?: boolean }[];
};
type Video = {
  id: string;
  url: string;
  name: string;
  isDemo?: boolean;
  duration: string | null;
  createdAt: string;
  updatedAt: string;
};
type Resources = {
  id: string;
  title: string;
  url: string;
  isDemo?: boolean;
  lectureId: string;
  createdAt: string;
  updatedAt: string;
};

interface ChaptersResponse {
  data?: ChaptersDTO[];
  error?: ApiError;
}

export const getChapters = async (
  chapterId: string
): Promise<ChaptersResponse> => {
  try {
    const response = await axios.get(`/chapter/all/${chapterId}`);
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
